import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { useGaranteedBlocs } from '../../../hooks/useCalendar/useRecordBlocs/useGaranteedBlocs';
import { FolderSection, LabelValue } from '../Elements';
import { numStr, t } from '../../common/Translate';
import { NRM_SUB_STATUS } from '../../../config';
import { currencySign } from '../../../Utils/currencySign';

export const GuranteedPriceBloc = ({ recordId }) => {
  const {
    pricingInProgress,
    tradeInPriceProposed,
    tradeInLinkedToNcNotConfirmedByClient,
    tradeInConfirmedByClient,
    tradeInWithOrderId,
    noTradeInPriceProposed,
    tradeInMaintainedPriceMaintained,
    tradeInMaintainedPriceModified,
    finalizationCompleted,
    finalizationAccepted,
    tradeInCancelled,
  } = NRM_SUB_STATUS;
  const {
    gotToGuranteedPrice,
    active,
    guaranteedPrice,
    ncOrder,
    getValuationPriceByStatus,
    nrmStatusId,
    nrmStatusLabel,
    firmValuation,
    countryPosId,
  } = useGaranteedBlocs(recordId);
  return (
    <FolderSection
      title={t('guranteedPriceTab')}
      dataTestid="guaranteed-price-bloc"
      action={gotToGuranteedPrice}
      error={false}
      showArrow={active}
    >
      {nrmStatusLabel && <LabelValue label={t('nrmStatus')} value={t(nrmStatusLabel)} />}
      {[
        pricingInProgress,
        tradeInPriceProposed,
        tradeInLinkedToNcNotConfirmedByClient,
        tradeInConfirmedByClient,
        tradeInWithOrderId,
      ].includes(nrmStatusId) && (
        <LabelValue
          label={t('ncOrderLinked')}
          value={![pricingInProgress, tradeInPriceProposed].includes(nrmStatusId) ? t('yes') : t('no')}
        />
      )}
      {nrmStatusId &&
        ![pricingInProgress, noTradeInPriceProposed].includes(nrmStatusId) &&
        guaranteedPrice.guaranteeablePrice !== null && (
          <LabelValue
            label={t('latestPrice')}
            value={currencySign(
              numStr(getValuationPriceByStatus() >= 0 ? getValuationPriceByStatus() : 0),
              null,
              countryPosId,
            )}
          />
        )}
      {[
        tradeInMaintainedPriceMaintained,
        tradeInMaintainedPriceModified,
        finalizationCompleted,
        finalizationAccepted,
        tradeInCancelled,
      ].includes(nrmStatusId) &&
        guaranteedPrice?.guaranteeablePriceCounter !== null && (
          <LabelValue
            label={t('priceAfterCounterAppraisal')}
            value={currencySign(numStr(guaranteedPrice?.guaranteeablePriceCounter), null, countryPosId)}
          />
        )}
      {nrmStatusId === tradeInLinkedToNcNotConfirmedByClient && firmValuation?.length > 1 && (
        <p className="multiple-nc-order">
          <FontAwesomeIcon icon={faBell} /> {t('alertMultipleNcOrder')}
        </p>
      )}
      {nrmStatusId === tradeInWithOrderId && guaranteedPrice?.guaranteeablePrice !== null && ncOrder() !== null && (
        <LabelValue label={`#${t('ncOrder')}`} value={`#${ncOrder()}`} />
      )}
    </FolderSection>
  );
};

GuranteedPriceBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
